module.exports = "/images/Rectangle1.png?d190ac1db6ad5f6d1c4a48efba8c99b2";